(function () {
    if (window.__muageGift) return;
    window.__muageGift = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function refresh(cart) {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: {}, sourceId: 'muage-gift', data: { source: 'muage-gift', itemCount: cart ? cart.item_count : undefined } };
      document.dispatchEvent(ev);
    }
    function post(url, body) {
      return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); });
    }

    document.addEventListener('change', function (e) {
      var box = e.target.closest && e.target.closest('[data-mg-check]');
      if (!box) return;
      var wrap = box.closest('[data-mg]');
      var variant = Number(wrap.dataset.variant);
      wrap.classList.add('is-busy');
      var job;
      if (box.checked) {
        job = post('cart/add.js', { items: [{ id: variant, quantity: 1 }] });
      } else {
        job = fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var updates = {};
          cart.items.forEach(function (it) { if (it.variant_id === variant) updates[it.key] = 0; });
          return post('cart/update.js', { updates: updates, attributes: { 'Message cadeau': '' } });
        });
      }
      job.then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(refresh)
        .catch(function () { wrap.classList.remove('is-busy'); box.checked = !box.checked; });
    });

    var timer;
    document.addEventListener('input', function (e) {
      var area = e.target.closest && e.target.closest('[data-mg-message]');
      if (!area) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        post('cart/update.js', { attributes: { 'Message cadeau': area.value } });
      }, 400);
    });
  })();

(function () {
  if (window.__muageCartLink) return;
  window.__muageCartLink = true;
  // L'icône panier de l'en-tête ouvre la page panier ; le panneau latéral reste utilisé après un ajout.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('header-actions .header-actions__action, header-actions [class*="cart-icon"]');
    if (!t) return;
    var drawer = t.closest('cart-drawer-component, .cart-drawer');
    if (!drawer || t.closest('dialog')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  }, true);
})();

(function () {
  if (window.__muageDrawerTitle) return;
  window.__muageDrawerTitle = true;
  // Dans le panneau latéral, le titre « Panier » mène à la page panier complète.
  var st = document.createElement('style');
  st.textContent = '.cart-drawer__heading{cursor:pointer}.cart-drawer__heading:hover{text-decoration:underline;text-underline-offset:4px}.cart-drawer__heading::after{content:"\\203A";font-size:.9em;opacity:.6;margin-inline-start:2px}';
  document.head.appendChild(st);
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.cart-drawer__heading');
    if (!h) return;
    e.preventDefault();
    window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  });
})();
